<template>
  <div>
    <!-- 头部图片部分 -->
    <div class="main-img">
      <div class="box-text t-center width100 height100">
        <el-carousel height="100%" :autoplay="false">
          <el-carousel-item>
            <div
              class="width100 height100 flex f-center f-jcenter carousel-item carousel-item-5"
            >
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div
              class="width100 height100 flex f-center f-jcenter carousel-item carousel-item-3"
            >
              <div  class="t-center c-fff width100 height80">
                <div>
                  <img src="../img/index/20240906142234.png" alt="" srcset="" width="280">
                </div>
                <div class="ma-t-40 ma-lr-auto" style="width:1000px">
                  <div class="fon-60">翠麟电影短片奖</div>
                <div class="ma-t-10 fon-24 t-left">
                  SHISW翠麟电影短片奖大赛是通过FilmFreeway官方认证的国际影像赛事。我们作为全球首家将 NFT/NFR 区块链技术应在国际影像赛事的节展品牌，至今我们已收到来自全球70多个国家的优秀短片作品。
                </div>
                <div class="flex f-center f-jcenter ma-t-20">
                  <!-- <div
                    class="btn-join c-p"
                    @click="$router.push({ path: '/competition/apply' })"
                  >
                    报名参赛
                  </div> -->
                </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div
              class="width100 height100 flex f-center f-jcenter carousel-item carousel-item-6"
            >
            </div>
          </el-carousel-item>
          
        </el-carousel>
      </div>
    </div>
   

    <!-- 获奖作品部分 -->
    <div class="box-works ma-t-60">
        <div class="container">
            <div class="menu-item fon-24">
                <div class="font-bold">获奖作品</div>
                <div class="font-bold">Award Winners Work</div>
                <img src="../img/index/index21.png"
                     class="item-right"
                     alt=""
                     srcset="" />
                <img src="../img/index/index22.png"
                     class="item-left"
                     alt=""
                     srcset="" />
            </div>
            <el-carousel :interval="3000" type="card" height="520px" indicator-position="none">
                <div class="flex f-wrap ma-t-40">
                    <el-carousel-item v-for="(item, index) in dataListWorks" :key="index">
                        <div class="item ma-b-40">
                            <div class="flex f-center p-r z-1">
                                <img class="b-r-50"
                                     width="60"
                                     height="60"
                                     src="../img/merge/i2.png" />
                                <div>
                                    <div class="ma-l-10 font-bold">{{ item.Director }}</div>
                                    <!-- <div class="t-omit-1 ma-l-10">曾与诸多国际品牌、一线明星</div> -->
                                </div>
                            </div>
                            <div>
                                <div class="item-shape">
                                    <img class=""
                                         :src="item.Image" />
                                </div>
                                <div class="t-center pa-tb-10 font-bold">{{ item.VideoName }}</div>
                                <div class="t-center font-bold">{{ item.PrizeName }}</div>
                            </div>
                        </div>
                    </el-carousel-item>
                </div>
            </el-carousel>
        <div class="t-center ma-tb-40">
          <el-button round class="home-btn" @click="$router.push({path:'/winnerList/index'})">获奖名单</el-button>
          <el-button round class="home-btn1" @click="$router.push({path:'/winnerList/history'})">历史获奖作品</el-button>
        </div>
      </div>
      <!-- 背景形状 -->
      <div class="bg-shape"></div>
    </div>

    <!-- 短片竞赛部分 -->
    <div class="box-contest ma-t-60">
      <div class="container">
        <div class="menu-item fon-24">
          <div class="font-bold">短片竞赛</div>
          <div class="font-bold">Short Film Competition</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div class="flex f-between ma-t-30">
          <img
            src="../img/index/index23.png"
            class="width50"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index24.png"
            class="width50"
            alt=""
            srcset=""
          />
        </div>
        <div class="flex f-between t-center">
          <div class="width50">
            <div class="font-bold ma-t-20">翠麟短片奖</div>
            <div class="ma-t-20">近30种比赛类型，好的作品总会发光</div>
            <!-- <div class="t-center ma-t-20">
              <el-button round class="home-btn" @click="$router.push({path:'/competition/apply'})">国内报名</el-button>
            </div> -->
          </div>
          <div class="width50">
            <div class="font-bold ma-t-20">翠麟剧本奖</div>
            <div class="ma-t-20">历史比赛获奖名单，希望有你</div>
            <!-- <div class="t-center ma-t-20">
              <el-button round class="home-btn"  @click="$router.push({path:'/competition/apply'})">国内报名</el-button>
            </div> -->
          </div>
        </div>
        <div class="pa-t-40 pa-b-40 t-center bg-fb004d ma-t-60">
          <div class="fon-36 c-fff">国际参赛报名</div>
          <img
            src="../img/index/index25.png"
            alt=""
            srcset=""
            style="width: 400px"
            class="ma-t-20 c-p"
            @click="tofilmFreeway()"
          />
          <div class="ma-t-30 c-fff">
            SHISW短片赛事通过FilmFreeway官方认证，FilmFreeway作为SHISW国际独家征片平台。
          </div>
        </div>
      </div>
      <!-- 背景形状 -->
      <div class="bg-shape"></div>
    </div>

     <!-- 新闻中心部分 -->
     <div class="box-news ma-t-60">
      <div class="container">
        <div class="menu-item fon-24">
          <div class="font-bold">新闻中心</div>
          <div class="font-bold">News Center</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div class="ma-t-40 flex f-between">
          <!-- <div class="width40 c-p" @click="toNewsDetail(hotNews[0].Id)">
            <img
              class="img_cover b-r-15"
              width="100%"
              height="330"
              v-if="hotNews && hotNews[0] && hotNews[0].Image"
              :src="hotNews[0].Image"
              alt=""
              srcset=""
            />
            <div
              class="width100 b-r-15"
              v-else
              style="height: 340px; background: #999"
            ></div>
            <div class="t-omit-1 ma-t-20 fon-20" v-if="hotNews && hotNews[0]">
              {{ hotNews[0].Name }}
            </div>
            <div class="t-omit-2 ma-t-10 c-666" v-if="hotNews && hotNews[0]">
              {{ hotNews[0].Summary }}
            </div>
            <div
              class="ma-t-10 c-666 flex f-between"
              v-if="hotNews && hotNews[0]"
            >
              <div>{{ hotNews[0].ReleaseTime }}</div>
              <div><i class="el-icon-right"></i></div>
            </div>
          </div> -->
          <div class="width100 pa-l-20 box-s-b-b">
            <div class="flex f-between ma-b-20 c-p" v-for="(item, index) in hotNews.slice(0, 3)" :key="index" @click="toNewsDetail(item.Id)">
              <!-- <img class="img_cover b-r-15 width40" width="100%" height="140" v-if="item && item.Image" :src="item.Image" alt="无图片" srcset="" />
              <div class="width40 b-r-15" v-else style="height: 160px; background: #999"></div> -->
              <div class="width100 box-s-b-b pa-l-10 flex flex-direction f-between">
                <div>
                  <div class="t-omit-1 ma-t-10 fon-20">
                    {{ item.Name }}
                  </div>
                  <div class="t-omit-2 ma-t-10 c-666" v-if="hotNews && hotNews[0]">
                    {{ hotNews[0].Summary }}
                  </div>
                </div>
                <div class="ma-b-10 c-666 flex f-between f-center">
                  <div>{{ item.ReleaseTime }}</div>
                  <div><i class="el-icon-right"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="t-center ma-tb-40">
          <el-button
            round
            class="home-btn c-p"
            @click="$router.push({ path: '/news/index' })"
            >更多资讯</el-button
          >
        </div>
      </div>

      <!-- 背景形状 -->
      <div class="bg-shape"></div>
    </div>

    <!-- 翠麟社区部分 -->
    <div class="box-community ma-t-80">
      <div class="container">
        <div class="menu-item fon-24">
          <div class="font-bold">翠麟社区</div>
          <div class="font-bold">Cuilin Community</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div class="flex box-wrap ma-t-30">
          <!-- 第一列 -->
          <div class="width20 height100">
            <div class="flex f-end height20 width100">
              <div class="bg-fb004d width50 height100 b-r-15 bg-eee"></div>
            </div>

            <div class="height40 width100 box-s-b-b pa-tb-10 c-p" @click="$router.push({ path: '/about/cuilin' })">
              <div class="wdith100 height100 bg-fb004d b-r-15 bg-img bg-img-1">
                <div class="pa-10">关于社区</div>
              </div>
            </div>

            <div class="height40 width100 flex">
              <div class="height100 width50 pa-r-10">
                <div class="height70 box-s-b-b pa-b-10">
                  <div class="wdith100 height100 bg-fb004d b-r-15 bg-eee"></div>
                </div>
                <div class="height30 bg-fb004d b-r-15 bg-eee"></div>
              </div>
              <div class="height100 width50">
                <div class="height50 box-s-b-b pa-b-10">
                  <div
                    class="wdith100 height100 bg-fb004d b-r-15 bg-fc7ba1"
                  ></div>
                </div>
                <div class="height50 bg-fb004d b-r-15 bg-eee"></div>
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="width20 ma-l-10" >
            <div class="width100 height50 pa-b-10 box-s-b-b">
              <div class="width100 height100 bg-fb004d b-r-15 bg-img bg-img-2">
                <div class="pa-10"></div>
              </div>
            </div>
            <div class="width100 height50 bg-fb004d b-r-15 bg-img bg-img-3 c-p" @click="$router.push({ path: '/crowd/index' })">
              <div class="pa-10">项目发现</div>
            </div>
          </div>
          <!-- 第三列 -->
          <div
            class="width30 height100 b-r-15 bg-fb004d ma-l-10 bg-img bg-img-4 c-p" @click="$router.push({ path: '/creation/index' })"
          >
            <div class="pa-10">创作训练营</div>
          </div>
          <!-- 第四列 -->
          <div class="width20 height100 ma-l-10">
            <div class="flex height20 width100">
              <div
                class="height100 width50 ma-r-10 b-r-15 bg-fb004d bg-fb004d"
              ></div>
              <div class="height100 width50">
                <div class="height70 width100 box-s-b-b pa-b-10">
                  <div class="bg-fb004d width100 height100 b-r-15 bg-eee"></div>
                </div>
                <div class="height30 width100 bg-fb004d b-r-15 bg-eee"></div>
              </div>
            </div>
            <div class="height40 width100 pa-tb-10 box-s-b-b c-p"  @click="$router.push({ path: '/vod/index' })">
              <div class="width100 height100 bg-fb004d b-r-15 bg-img bg-img-5">
                <div class="pa-10">点播平台</div>
              </div>
            </div>
            <div class="height40 width100 bg-fb004d b-r-15 bg-img bg-img-6 c-p" @click="$router.push({ path: '/talent/index' })">
              <div class="pa-10">翠麟精英</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 背景形状 -->
      <div class="bg-shape"></div>
    </div>

    <!-- 官方新媒体矩阵 -->
    <div class="box-media ma-t-60">
      <div class="container">
        <div class="menu-item fon-24">
          <div class="font-bold">官方新媒体矩阵</div>
          <div class="font-bold">Official New Media</div>
          <img
            src="../img/index/index21.png"
            class="item-right"
            alt=""
            srcset=""
            style="width:85%"
          />
          <img
            src="../img/index/index22.png"
            class="item-left"
            alt=""
            srcset=""
          />
        </div>
        <div class="flex f-wrap  ma-t-80 t-center">
          <div class="media-logo">
            <img src="../img/index/media (1).png" alt="" srcset="" />
            <div>微博</div>
            <img src="../img/header/wb.png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo">
            <img src="../img/index/media (2).png" alt="" srcset="" />
            <div>小红书</div>
            <img src="../img/header/xhs.png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo">
            <img src="../img/index/media (3).png" alt="" srcset="" />
            <div>豆瓣</div>
            <img src="../img/header/douban.png" class="media-qrcode" alt="" srcset="">

          </div>
          <div class="media-logo">
            <img src="../img/index/media (4).png" alt="" srcset="" />
            <div>抖音</div>
            <img src="../img/header/dy.png" class="media-qrcode" alt="" srcset="">

          </div>
          <div class="media-logo">
            <img src="../img/index/media (5).png" alt="" srcset="" />
            <div>公众号</div>
            <img src="../img/merge/qrcode.png" class="media-qrcode" alt="" srcset="">
            
          </div>
          <div class="media-logo">
            <img src="../img/index/media (6).png" alt="" srcset="" />
            <div>视频号</div>
            <img src="../img/merge/weixinvideo.png" class="media-qrcode" alt="" srcset="">
            
          </div>
          <div class="media-logo">
            <img src="../img/index/media (7).png" alt="" srcset="" />
            <div>喜马拉雅</div>
            <img src="../img/merge/xmly.png" class="media-qrcode" alt="" srcset="">

          </div>
          <div class="media-logo">
            <img src="../img/index/media (8).png" alt="" srcset="" />
            <div>哔哩哔哩</div>
            <img src="../img/merge/bilili.png" class="media-qrcode" alt="" srcset="">

          </div>
          
          <div class="media-logo">
            <img src="../img/index/media (9).png" alt="" srcset="" />
            <div>新片场</div>
            <img src="../img/header/xpc.png" class="media-qrcode" alt="" srcset="">
          </div>

          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (11).png" alt="" srcset="" />
            <div>爱奇艺</div>
            <img src="../img/header/media (11).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (12).png" alt="" srcset="" />
            <div>快传</div>
            <img src="../img/header/media (12).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (13).png" alt="" srcset="" />
            <div>快手</div>
            <img src="../img/header/media (13).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (14).png" alt="" srcset="" />
            <div>好看</div>
            <img src="../img/header/media (14).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (15).png" alt="" srcset="" />
            <div>微视</div>
            <img src="../img/header/media (15).png" class="media-qrcode" alt="" srcset="">
          </div>
          <!--<div class="media-logo media_logoimg" >
            <img src="../img/index/media (16).png" alt="" srcset="" />
            <div>秒拍</div>
            
          </div>-->                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (17).png" alt="" srcset="" />
            <div>企鹅号</div>
            <img src="../img/header/media (17).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (18).png" alt="" srcset="" />
            <div>搜狐</div>
            <img src="../img/header/media (18).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (19).png" alt="" srcset="" />
            <div>腾讯</div>
            <img src="../img/header/media (19).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (20).png" alt="" srcset="" />
            <div>头条</div>
            <img src="../img/header/media (20).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (21).png" alt="" srcset="" />
            <div>一点</div>
            <img src="../img/header/media (21).png" class="media-qrcode" alt="" srcset="">
          </div>
          <div class="media-logo media_logoimg" >
            <img src="../img/index/media (22).png" alt="" srcset="" />
            <div>简书 </div>
            <img src="../img/header/media (22).png" class="media-qrcode" alt="" srcset="">
          </div>


        </div>
        <!-- 背景形状 
        <div class="bg-shape"></div>-->
        <div class="ma-t-30 t-center">
          <img src="../img/qrcode.png" alt="" srcset="" width="150">
          <img src="../img/20240925095712.jpg" alt="" class="ma-l-40" srcset="" width="150">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { HomeArticle,getByDuringMonth } from "../api.js";
  export default {
    data() {
      return {
        hotNews: [],
        dataListWorks:[
      
        ],
      };
    },
    created() {
      HomeArticle().then((res) => {
        if (res.data.Code == 0) {
          this.hotNews = res.data.Data;
        }
      });
      this.loadData();
    },
    methods: {
      open2(){},
      loadData() {
        getByDuringMonth().then((res) => {
          this.dataListWorks = res.data.Data;
          console.log(res);
        });
      },
      toNewsDetail(id) {
        window.open("/news/detail?id=" + id);
      },
      //跳转海外报名网站
      tofilmFreeway(){
        window.open('https://filmfreeway.com/ShanghaiShortWeek','_black')
      },
    },
  };
</script>
<style lang="scss" scoped>
// 公共部分
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.p-r {
  position: relative;
}
.z-1 {
  z-index: 1;
}
.home-btn {
  width: 214px;
  height: 50px;
  background: #fb004d;
  border-radius: 25px;
  color: #fff;
}
.home-btn1{
  width: 214px;
  height: 50px;
  background: #67c23a;
  border-radius: 25px;
  color: #fff;
}
.bg-shape {
  z-index: -1;
}
// 第一部分
.main-img {
  height: calc(
    100vh - 100px
  ); //减去顶部菜单的距离，实现任意屏幕的第一屏仅显示菜单和图片效果
  position: relative;

  .carousel-item {
    position: relative;
    div {
      z-index: 1;
    }
  }
  .carousel-item-1 {
    background: url("../img/index/20230814092351.jpg") no-repeat;
    background-size: cover;
  }
  .carousel-item-2 {
    background: url("../img/index/4.jpg") no-repeat;
    background-size: cover;
  }
  .carousel-item-3 {
    background: url("../img/index/20240923151808.jpg") no-repeat;
    background-size: cover;
  }
  .carousel-item-4 {
    background: url("../img/index/3.jpg") no-repeat;
    background-size: cover;
  }
  .carousel-item-5 {
    background: url("../img/index/20240923095810.jpg") no-repeat;
    background-size: cover;
  }
  .carousel-item-6 {
    background: url("../img/index/20240926140953.jpg") no-repeat;
    background-size: cover;
  }

  // .carousel-item::after {
  //   content: "";
  //   position: absolute;
  //   background: #000;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   opacity: 0.3;
  //   z-index: 0;
  // }
  .box-text {
    position: absolute;
    .title {
      font-size: 36px;
      font-weight: bold;
    }
    .btn-join {
      width: 257px;
      height: 60px;
      background: #fb004d;
      border-radius: 30px;
      line-height: 60px;
      color: #fff;
    }
  }
}
//新闻中心部分
.box-news {
  position: relative;
  overflow: hidden;
  .bg-shape {
    width: 1000px;
    height: 1000px;
    top: 0;
    right: 0;
    position: absolute;
    background: linear-gradient(
      -45deg,
      #fb004d,
      #fb004d 50%,
      transparent 50%,
      transparent 100%
    );
    opacity: 0.04;
  }
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
//获奖作品部分
    .box-works {
        position: relative;
        overflow: hidden;

        .item-shape {
            width: 280px;
            height: 340px;
            //clip-path: path( "M0,20 Q0,0 20,0 L260,40 Q280,40 280,60 L280,220 Q280,240 260,240 L20,240 Q0,240 0,220 L0,20 Z" );
            margin-top: -10px;
            img {
                width: 280px;
                height: 340px;
                object-fit: contain;
                border-radius: 10px;
            }
        }

        .item {
            width: 50%;
            margin: 0 25%;
            padding: 20px 0;
        }

        .item:not(:nth-child(4n)) {
            margin-right: calc(4% / 3);
        }

        .bg-shape {
            width: 1200px;
            height: 1020px;
            border-radius: 50%;
            top: 0;
            left: -200px;
            position: absolute;
            opacity: 0.04;
            background: #fb004d;
        }
    }

// 短片竞赛部分
.box-contest {
  position: relative;
  .bg-shape {
    width: 1200px;
    height: 1020px;
    border-radius: 50%;
    top: 0;
    right: -200px;
    position: absolute;
    opacity: 0.04;
    background: #fb004d;
  }
}

//翠麟社区部分
.box-community {
  position: relative;
  .box-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 300px;
    user-select:none;
  }
  .bg-img-1 {
    background: url("../img/index/index26.png") no-repeat;
  }
  .bg-img-2 {
    background: url("../img/index/index27.png") no-repeat;
  }
  .bg-img-3 {
    background: url("../img/index/index28.png") no-repeat;
  }
  .bg-img-4 {
    background: url("../img/index/index29.png") no-repeat;
  }
  .bg-img-5 {
    background: url("../img/index/index30.png") no-repeat;
  }
  .bg-img-6 {
    background: url("../img/index/index31.png") no-repeat;
  }
  .bg-img {
    background-size: cover;
    position: relative;
    div {
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 1;
      color: #fff;
    }
  }
  .bg-img::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    background: none;
    background: linear-gradient(to top, #000000 0%, transparent 50%);
  }
  .bg-eee {
    background: #d2d2d2;
  }
  .bg-fc7ba1 {
    background: #fc7ba1;
  }
  .bg-shape {
    width: 1200px;
    height: 800px;
    border-radius: 50%;
    top: 100px;
    left: -400px;
    position: absolute;
    opacity: 0.04;
    background: #fb004d;
  }
}

// 官方新媒体矩阵
.box-media {
  margin-bottom: 230px;
}
.media-logo{
      position: relative;
      width:10%;
      margin-bottom:20px;
      img{
        width: 60%;
      }
      .media-qrcode{
        width: 200px;
        position:absolute;
        opacity: 0;
        left: -260px;
        top: 140px;
        z-index: -2;
        transition: left .3s;
        -webkit-transition:left .3s;
      }
}

.media-logo:hover .media-qrcode{
   z-index: 3;
   top: 140px;
   left: -50px;
   opacity: 1;
}
.t-between{
  text-align: justify;
  text-align-last: justify;
}
.t-between :after{
    content: '';
    display: inline-block;
    width: 100%;
}

</style>